'use strict';

require('../../company/publications/CompanyPublicationFileService.js');
require('../../company/publications/CompanyPublicationActivity.js');
require('../../company/publications/CompanyPublicationActivityDirective.js');
require('../../company/publications/CompanyPublicationWallDirective.js');
require('../../company/checklist/CompanyChecklistService.js');

function CompanyGuestPublicationsDetailCtrl(
  $scope,
  publication,
  files,
  checklists,
  uploadTracker,
  translations,
  $stateParams,
  $state,
  CompanyPublicationService,
  CompanyPublicationFileService,
  $sce,
  config,
  activityService
) {
  $scope.publication = publication;
  $scope.files = files;
  $scope.checklists = checklists;
  $scope.translations = translations;
  $scope.activityService = activityService;

  $scope.tabs = [
    {
      'title': $sce.trustAsHtml(translations['publication.information']),
      'content': '',
      'template': 'partials/company-guest/publications/detail/latest.html',
      'icon': 'info-circle'
    }
  ];

  $scope.tabs.activeTab = 0;

  $scope.uploadFilesForPublication = function(files, publicationId) {
    return uploadTracker(files.map(function(f) {
      return {
        url:  config.apiBase + "/companies/" + $stateParams.companyId + "/publications/" + publicationId + "/files",
        file: f,
      };
    }));
  };

  $scope.onFileSelect = function($files) {
    if (!$scope.publication.uploadLock || $scope.publication.uploadLock.id === $scope.currentUser.id) {
      $scope.uploadFilesForPublication($files, $stateParams.publicationId).then(function(files) {
        publication.versionNumber += files.length;
        $scope.$broadcast("files-uploaded");
      });
    } else {
      growl.addErrorMessage(translations['publication.file-upload-locked']);
      return false;
    }
  };

  $scope.$on("files-uploaded", function() {
    CompanyPublicationFileService.query({
      companyId:     $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      limit:         1
    }).$promise.then(function(files) {
      $scope.files = files;
      if ($scope.files[0]) {
        $scope.$broadcast('fileProcessed', $scope.files[0]);
        $scope.$emit('publicationSaved');
      }
    });
  });
}

CompanyGuestPublicationsDetailCtrl.resolve = {
  publication: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.get({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, checklistService){
    return checklistService.query({
      companyId: $stateParams.companyId,
      relativeID: $stateParams.publicationId
    }).$promise;
  }],
  files: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  translations: ['$translate', function($translate) {
    return $translate([
      'publication.information',
      'publication.file-upload-locked'
    ]);
  }],
  activityService: ['$stateParams', 'CompanyPublicationActivity', function($stateParams, CompanyPublicationActivity) {
    return new CompanyPublicationActivity($stateParams.companyId, $stateParams.publicationId);
  }]
};
module.exports = CompanyGuestPublicationsDetailCtrl;

angular.module('dokiv')
  .controller('CompanyGuestPublicationsDetailCtrl', [
  '$scope',
  'publication',
  'files',
  'checklists',
  'UploadTracker',
  'translations',
  '$stateParams',
  '$state',
  'CompanyPublicationService',
  'CompanyPublicationFileService',
  '$sce',
  'config',
  'activityService',
  CompanyGuestPublicationsDetailCtrl
]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company-guest/publications/CompanyGuestPublicationsDetailCtrl.js
// module id = 300
// module chunks = 0